import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import { firstError } from 'common/validation';
import { getStep } from 'common/selectors';
import * as steps from 'common/steps';

import {
  FIELD_BLURRED,
  PRIMARY_CATEGORY_CHANGED,
  SECONDARY_CATEGORY_CHANGED,
  TERTIARY_CATEGORY_CHANGED,
} from 'dissertation-info/dissertationInfoActions';

import { getErrors, getFields } from 'common/stepReducerUtil';

import { getCategories } from 'dissertation-info/dissertationInfoReducer';

import Autocomplete from 'general-components/Autocomplete';
import styles from './DissertationInfoCategories.css';

const getAvailableCategoriesSource = (disabledCategories, allCategories) =>
  R.pipe(
    R.filter(({ categoryId }) =>
      R.none(
        R.propEq('categoryId', categoryId),
        R.filter(R.identity, disabledCategories),
      ),
    ),
    R.map(({ categoryId, categoryName }) => [categoryId, categoryName]),
    R.fromPairs,
  )(allCategories);

const DissertationInfoCategories = ({
  primaryCategory,
  secondaryCategory,
  tertiaryCategory,
  categories,
  errors,
  onBlur,
  onPrimaryCategoryChanged,
  onSecondaryCategoryChanged,
  onTertiaryCategoryChanged,
}) => (
  <div>
    <div className={styles.row}>
      <Autocomplete
        label="Primary category"
        multiple={false}
        source={getAvailableCategoriesSource(
          [secondaryCategory, tertiaryCategory],
          categories,
        )}
        showSuggestionsWhenValueIsSet={true}
        suggestionMatch="anywhere"
        direction="down"
        value={R.path(['categoryId'], primaryCategory)}
        onChange={onPrimaryCategoryChanged}
        error={firstError(errors, 'primaryCategory.categoryId')}
        onQueryChange={query => {
          if (R.isEmpty(query)) {
            onPrimaryCategoryChanged('');
          }
        }}
      />
    </div>

    <div className={styles.row}>
      <Autocomplete
        label="Secondary category (optional)"
        multiple={false}
        source={getAvailableCategoriesSource(
          [primaryCategory, tertiaryCategory],
          categories,
        )}
        showSuggestionsWhenValueIsSet={true}
        suggestionMatch="anywhere"
        direction="down"
        value={R.path(['categoryId'], secondaryCategory)}
        onChange={onSecondaryCategoryChanged}
        error={firstError(errors, 'secondaryCategory.categoryId')}
        onQueryChange={query => {
          if (R.isEmpty(query)) {
            onSecondaryCategoryChanged('');
          }
        }}
      />
    </div>

    <div className={styles.row}>
      <Autocomplete
        label="Tertiary category (optional)"
        multiple={false}
        source={getAvailableCategoriesSource(
          [primaryCategory, secondaryCategory],
          categories,
        )}
        showSuggestionsWhenValueIsSet={true}
        suggestionMatch="anywhere"
        direction="down"
        value={R.path(['categoryId'], tertiaryCategory)}
        onChange={onTertiaryCategoryChanged}
        error={firstError(errors, 'tertiaryCategory.categoryId')}
        onQueryChange={query => {
          if (R.isEmpty(query)) {
            onTertiaryCategoryChanged('');
          }
        }}
      />
    </div>
  </div>
);

const mapState = R.pipe(
  getStep(steps.DISSERTATION_INFO),
  R.applySpec({
    categories: getCategories,
    errors: getErrors,
    primaryCategory: R.pipe(getFields, R.prop('primaryCategory')),
    secondaryCategory: R.pipe(getFields, R.prop('secondaryCategory')),
    tertiaryCategory: R.pipe(getFields, R.prop('tertiaryCategory')),
  }),
);

const mapDispatch = dispatch => ({
  onBlur: (field, value) => dispatch({ type: FIELD_BLURRED, field, value }),
  onPrimaryCategoryChanged: (categoryId, event) =>
    dispatch({ type: PRIMARY_CATEGORY_CHANGED, categoryId }),
  onSecondaryCategoryChanged: (categoryId, event) =>
    dispatch({ type: SECONDARY_CATEGORY_CHANGED, categoryId }),
  onTertiaryCategoryChanged: (categoryId, event) =>
    dispatch({ type: TERTIARY_CATEGORY_CHANGED, categoryId }),
});

export default connect(mapState, mapDispatch)(DissertationInfoCategories);



// WEBPACK FOOTER //
// ./src/dissertation-info/components/DissertationInfoCategories.js